// The code in this file will load on every page of your site
import wixWindow from 'wix-window';

$w.onReady(function () {
	if(wixWindow.formFactor === "Desktop"){
  $w("#form2").hide();
}
});